import cloud_upload from "./svg/cloud_upload.svg";
import development from "./svg/development.svg";
import logo from "./svg/logotipo-gen-studio.svg";
import robot from "./svg/robot.svg";
import robotic_agent from "./svg/robotic-agent.svg";
import serious_face from "./svg/seriuos-face.svg";
import user from "./svg/user.svg";

export const Logo = ({ height, width, style }) => {
  return (
    <img
      src={logo}
      width={width}
      height={height}
      style={{ ...style }}
      alt="cloud upload"
    />
  );
};

export const CloudUpload = ({ size }) => {
  return (
    <img src={cloud_upload} width={size} height={size} alt="cloud upload" />
  );
};

export const RoboticAgent = ({ size }) => {
  return (
    <img src={robotic_agent} width={size} height={size} alt="Robotic Agent" />
  );
};

export const Development = ({ size, color = "black" }) => {
  return (
    <img
      src={development}
      width={size}
      height={size}
      color={color}
      alt="Development"
    />
  );
};

export const SeriousFace = ({ size }) => {
  return (
    <img src={serious_face} width={size} height={size} alt="Serious Face" />
  );
};

export const User = ({ size }) => {
  return <img src={user} width={size} height={size} alt="User" />;
};

export const Robot = ({ size }) => {
  return <img src={robot} width={size} height={size} alt="Robot" />;
};
